import { IStore } from 'store/configureStore';

export const selectIsClientPaySettingsUpdating = (state: IStore) =>
    state.modules.settings.clientsSettings.clients.paySettings.isUpdating;
